import { writable } from "svelte/store";

export const currentCity = writable(null);
export const autoSuggestions = writable([]);
export const cartLoginDetails = writable(null);
